@if (projects() === null) {
  <div class="oph-loading-container">
    <oph-loading></oph-loading>
  </div>
} @else if (projects()?.length === 0) {
  <div class="list-container">
    <h2 class="list-title">Create your first project.</h2>

    <div class="type-cards">
      <!-- Challenge Card -->
      <div class="type-card">
        <div class="type-icon-wrapper">
          <img src="assets/img/icons/challenge-builder/challenge.png" alt="Challenge" class="type-icon" />
        </div>
        <div class="type-card-body">
          <div class="type-text">
            <span class="type-label">Challenge</span>
            <span class="type-description">Work toward a goal on a repeating cycle.</span>
          </div>
          <oph-button color="green" (buttonClick)="onCreate('challenge')">
            Create
            <mat-icon svgIcon="chevron-right"></mat-icon>
          </oph-button>
        </div>
      </div>

      <!-- Project Card -->
      <div class="type-card">
        <div class="type-icon-wrapper">
          <img src="assets/img/icons/challenge-builder/project.png" alt="Project" class="type-icon" />
        </div>
        <div class="type-card-body">
          <div class="type-text">
            <span class="type-label">Project</span>
            <span class="type-description">Build a collaborative project with tasks.</span>
          </div>
          <oph-button color="green" (buttonClick)="onCreate('project')">
            Create
            <mat-icon svgIcon="chevron-right"></mat-icon>
          </oph-button>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="projects-list">
    <div class="projects-header">
      <h2 class="projects-title">My Projects &amp; Challenges</h2>
      <oph-button color="green" [style]="{padding: '0 30px'}" (buttonClick)="onCreate()">Add New</oph-button>
    </div>

    <div class="projects-rows">
      @for (item of allProjects(); track item._id) {
        <button class="project-row" (click)="navigateTo(item)">
          <!-- Left side: Icon + Label -->
          <div class="row-left">
            @if (item.isChallenge) {
              <div class="row-icon challenge-icon">
                <img src="assets/img/icons/projects-challenge.svg" alt="" />
              </div>
            } @else {
              <div class="row-icon" [style.background-color]="item.color"></div>
            }
            <span class="row-label">{{ item.label }}</span>
          </div>

          <!-- Right side: Info + Status + Menu -->
          <div class="row-right">
            @if (item.status === 'active') {
              @if (item.isChallenge) {
                @if (item.startDateTime) {
                  <span class="row-info date-info">
                    <em class="date-prefix">{{ item.datePrefix }}</em>
                    {{ item.startDateTime | date: 'MMM d, yyyy' }}
                  </span>
                }
                <span class="row-info count-info">{{ item.targetCount }} targets</span>
              } @else {
                <span class="row-info count-info">{{ item.taskCount }} tasks</span>
                <span class="row-info count-info">{{ item.metricCount }} metrics</span>
              }
            }

            <span class="status-badge" [class]="item.statusClass">
              {{ item.statusLabel }}
            </span>

            <project-row-menu [project]="item" [isChallenge]="item.isChallenge" />
          </div>
        </button>
      }
    </div>
  </div>
}
